import { signal } from "@preact/signals";
export const isMediaTabOpened = signal(false);
export const isReflectionTabOpened = signal(false);
